import { QUESTIONAIRE_RESULTS_ENUM } from '../../utils/inyoUtils';

export const questions = [
  {
    id: 'is-enter-point-inyo-nf',
    description: 'Will you be starting from an Inyo National Forest entry point?',
    type: 'single-choice-radio',
    choices: [
      {
        description: 'Yes',
        value: 'yes'
      },
      {
        description: 'No',
        value: 'no'
      }
    ]
  },
  {
    id: 'choose-assistance',
    description: 'Are you getting assistance from any commercial guide services (like a pack station or guide)?',
    type: 'single-choice-radio',
    choices: [
      {
        description: 'No',
        value: 'no'
      },
      {
        description: 'Yes',
        value: 'yes'
      }
    ]
  },
  {
    id: 'start-end-visit-mt-whitney',
    description: 'Will you be starting at, visiting, or ending at Mt Whitney?',
    type: 'single-choice-radio',
    choices: [
      {
        description: 'No',
        value: 'no'
      },
      {
        description: 'Yes, starting at Mt. Whitney',
        value: 'yes-starting-mt-whitney'
      },
      {
        description: 'Yes, ending at Mt. Whitney',
        value: 'yes-ending-mt-whitney'
      }
    ]
  },
  {
    id: 'hike-last-for-one-day',
    description: 'Does your entire hike only last for one day?',
    type: 'single-choice-radio',
    choices: [
      {
        description: 'Yes',
        value: 'yes'
      },
      {
        description: 'No',
        value: 'no'
      }
    ]
  },
  {
    id: 'going-beyond-first-lake',
    description: 'Are you going beyond the first lake (Lone Pine Lake or Lower Boy Scout Lake)?',
    type: 'single-choice-radio',
    choices: [
      {
        description: 'Yes',
        value: 'yes'
      },
      {
        description: 'No',
        value: 'no'
      }
    ]
  },
  {
    id: 'starting-at-nfolk-of-lonepines',
    description: 'Are you starting on the Mt Whitney Trail or the N. Fork of Lone Pine Trail?',
    type: 'single-choice-radio',
    choices: [
      {
        description: 'Mt Whitney Trail',
        value: 'mt-whitney-trail'
      },
      {
        description: 'N. Fork of Lone Pine Trail',
        value: 'n-folk-lone-pine-trail'
      }
    ]
  },
  {
    id: 'starting-at-nfolk-of-lonepines-exiting-mt-whitney',
    description: 'Will you be exiting through Mt Whitney (Trail Crest Exit)?',
    type: 'single-choice-radio',
    choices: [
      {
        description: 'No',
        value: 'no'
      },
      {
        description: 'Yes',
        value: 'yes'
      }
    ]
  }
];

export const questionnaire = {
  'is-enter-point-inyo-nf': {
    yes: {
      'choose-assistance': {
        yes: {
          result: QUESTIONAIRE_RESULTS_ENUM.CONTACT_COMMERCIAL_OPERATORS
        },
        no: {
          'start-end-visit-mt-whitney': {
            'yes-starting-mt-whitney': {
              'hike-last-for-one-day': {
                yes: {
                  'going-beyond-first-lake': {
                    yes: {
                      result: QUESTIONAIRE_RESULTS_ENUM.MT_WHITNEY_DAY_USE_PERMIT
                    },
                    no: {
                      result: QUESTIONAIRE_RESULTS_ENUM.No_NEED_FOR_PERMIT
                    }
                  }
                },
                no: {
                  'starting-at-nfolk-of-lonepines': {
                    'mt-whitney-trail': {
                      result: QUESTIONAIRE_RESULTS_ENUM.MT_WHITNEY_TRAIL_OVERNIGHT_PERMIT
                    },
                    'n-folk-lone-pine-trail': {
                      'starting-at-nfolk-of-lonepines-exiting-mt-whitney': {
                          yes: {
                            result: QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_EXITING_MT_WHITNEY
                          },
                          no: {
                            result: QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_PERMIT_2
                          }
                      }
                    }
                  }
                }
              }
            },
            'yes-starting-ending-mt-whitney': {
              result: QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_PERMIT_2
            },
            'yes-ending-mt-whitney': {
              result: QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_EXITING_MT_WHITNEY
            },
            no: {
              result: QUESTIONAIRE_RESULTS_ENUM.INYO_OVERNIGHT_PERMIT
            }
          }
        }
      }
    },
    no: {
      result: QUESTIONAIRE_RESULTS_ENUM.CONTACT_AGENCY
    }
  }
};

// convert questions to questions by id
export function getQuestionsById(qs) {
  const ret = {};
  qs.forEach((q) => {
    ret[q.id] = q;
  });
  return ret;
}

// convert answers to answers by question id
export function getAnswersById(answers) {
  const ret = {};
  answers.forEach((a) => {
    ret[a.id] = a;
  });
  return ret;
}

// convert choices to choices by value
export function getChoicesByValue(choices) {
  const ret = {};
  choices.forEach((c) => {
    ret[c.value] = c;
  });
  return ret;
}

// find next question in questionnaire tree relative to current question and answers
export function getNextQuestion(currentQuestion, answers) {
  let questionId = Object.keys(questionnaire)[0]; // root/first question
  const answersById = getAnswersById(answers);
  const questionsById = getQuestionsById(questions);
  if (!currentQuestion) {
    // return first question
    return questionsById[questionId];
  }
  // parse questionnaire tree and find next question relative to current given answers
  let followUpChoices = questionnaire[questionId];
  let followUpQuestion = null;
  let foundCurrentQuestion = false;
  while (true) {
    if (followUpChoices.result) {
      // if next choice is a result, then return it
      return followUpChoices.result;
    }
    if (currentQuestion.id === questionId) {
      foundCurrentQuestion = true;
    }
    const answer = answersById[questionId];
    if (!answer) {
      // if no answer to current question, then return current question from tree
      return questionsById[questionId];
    }
    // find follow up question
    let alreadyAnswered = false;
    for (const choice in followUpChoices) {
      if (answer.value === choice) {
        followUpQuestion = followUpChoices[choice];
        alreadyAnswered = true;
        break;
      }
    }
    if (!alreadyAnswered) {
      // if question was not answered then return it, regardless of currentQuestion
      return questionsById[questionId];
    }
    if (followUpQuestion.result) {
      // if next question is an end result, then return it
      return followUpQuestion.result;
    }
    questionId = Object.keys(followUpQuestion)[0];
    if (foundCurrentQuestion) {
      // found next question then return it
      return questionsById[questionId];
    }
    followUpChoices = followUpQuestion[questionId];
  }
}
